import { Link } from 'react-router-dom';
import Layout from '@/components/base/Layout';
import SEO from '@/components/base/SEO';
import Breadcrumb from '@/components/base/Breadcrumb';
import { siteInfo, articles } from '@/mocks/data';

function ArticlesSEO() {
  return (
    <SEO
      title={`体育资讯 - ${siteInfo.name} | 体育动态 运动知识 赛事指南`}
      description="满冠体育资讯频道，为您提供最新的体育赛事动态、专业运动知识、培训技巧、装备推荐和运动健康指南。"
      keywords="体育资讯,运动知识,赛事指南,培训技巧,装备推荐,运动健康,满冠体育"
      canonicalUrl={`${siteInfo.url}/articles`}
      structuredData={{
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '体育资讯 - 满冠体育',
        url: `${siteInfo.url}/articles`,
        description: '满冠体育资讯频道，提供最新体育动态与专业知识。',
        isPartOf: { '@id': `${siteInfo.url}#website` },
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: siteInfo.url },
            { '@type': 'ListItem', position: 2, name: '体育资讯', item: `${siteInfo.url}/articles` },
          ],
        },
      }}
    />
  );
}

export default function Articles() {
  return (
    <Layout>
      <ArticlesSEO />

      <div className="pt-16 md:pt-18">
        <div className="bg-background-100">
          <div className="container-custom py-8 md:py-12">
            <Breadcrumb items={[{ label: '体育资讯' }]} />
            <h1 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
              体育资讯
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
              最新体育动态、专业运动知识、赛事指南与培训技巧，助您成为更专业的运动达人
            </p>
          </div>
        </div>

        <div className="container-custom py-8 md:py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {articles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="bg-background-100 rounded-lg overflow-hidden group no-underline hover:ring-2 hover:ring-primary-200 transition-all duration-300"
              >
                <div className="relative h-48 md:h-52 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-accent-500 text-background-50 rounded-md text-xs font-medium">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h2 className="text-base md:text-lg font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors font-heading">
                    {article.title}
                  </h2>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-line"></i> {article.author}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i> {article.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i> {article.readTime}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}